import { render, staticRenderFns } from "./DraggableImageContainer.vue?vue&type=template&id=71ef4270&scoped=true&"
import script from "./DraggableImageContainer.vue?vue&type=script&lang=js&"
export * from "./DraggableImageContainer.vue?vue&type=script&lang=js&"
import style0 from "./DraggableImageContainer.vue?vue&type=style&index=0&id=71ef4270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef4270",
  null
  
)

export default component.exports